import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackAnalyticsEvent } from '../lib/api';

/**
 * Hook to track page views automatically
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view
    trackAnalyticsEvent('page_view', location.pathname, null, {
      search: location.search,
      referrer: document.referrer
    });
  }, [location.pathname]);
};

/**
 * Track a click event
 */
export const trackClick = (element, metadata = null) => {
  trackAnalyticsEvent('click', window.location.pathname, element, metadata);
};

/**
 * Track a signup event
 */
export const trackSignup = (method, metadata = null) => {
  trackAnalyticsEvent('signup', window.location.pathname, method, metadata);
};

/**
 * Track a conversion event
 */
export const trackConversion = (type, metadata = null) => {
  trackAnalyticsEvent('conversion', window.location.pathname, type, metadata);
};

export default usePageTracking;
